import { FC } from 'react';
import styles from './index.module.scss';

export const DiagnosisTools: FC = () => {
  return (
    <section className={styles.linkListGroup}>
      <h2 className={styles.linkListGroup__title}>診断・書類作成ツール</h2>
      <ul className={styles.linkListGroup__column1}>
        <li>
          <a
            href="//assess.doda.jp/"
            className={styles.linkListGroup__columnItem}
          >
            <img
              className={styles.linkListGroup__cardTypeImage}
              src="//src.doda.jp/cmn_web/img/index/sp/banner_service_01.png"
              alt="年収査定"
            />
            <div className={styles.linkListGroup__cardContent}>
              <p className={styles.linkListGroup__cardLabel}>年収査定</p>
              <p className={styles.linkListGroup__cardTitle}>
                あなたの適正年収とキャリアの可能性が分かる
              </p>
            </div>
          </a>
        </li>
        <li>
          <a href="/type/" className={styles.linkListGroup__columnItem}>
            <img
              className={styles.linkListGroup__cardTypeImage}
              src="//src.doda.jp/cmn_web/img/guide/thumb120_type.png"
              alt="転職タイプ診断"
            />
            <div className={styles.linkListGroup__cardContent}>
              <p className={styles.linkListGroup__cardLabel}>
                転職タイプ診断（適職診断）
              </p>
              <p className={styles.linkListGroup__cardTitle}>
                適職探しのヒントが見つかる！
              </p>
            </div>
          </a>
        </li>
        <li>
          <a
            href="/guide/rireki/builder/"
            className={styles.linkListGroup__columnItemLast}
          >
            <img
              className={styles.linkListGroup__cardTypeImage}
              src="//src.doda.jp/cmn_web/img/index/sp/banner_rireki_builder.png"
              alt="履歴書作成ツール"
            />
            <div className={styles.linkListGroup__cardContent}>
              <p className={styles.linkListGroup__cardLabel}>
                履歴書作成ツール
              </p>
              <p className={styles.linkListGroup__cardTitle}>
                項目を入力するだけで履歴書を簡単作成
              </p>
            </div>
          </a>
        </li>
      </ul>
    </section>
  );
};
